/** O endereço só é ativado depois que o vídeo real estiver publicado no R2. */
export function campaignVideoUrl(value = import.meta.env.VITE_FIFTY_PLUS_VIDEO_URL): string | null {
  if (!value) return null
  try {
    const url = new URL(value)
    return url.origin === 'https://videos.oficina-ia.app' && url.pathname.endsWith('.mp4') && !url.username && !url.password
      ? url.href : null
  } catch {
    return null
  }
}

/**
 * O poster vive no próprio site: a CSP só libera imagens da origem ('self'),
 * enquanto `media-src` libera o MP4 do domínio de vídeos.
 */
export const campaignPosterUrl = '/assets/video/apresentacao-poster.jpg'
